import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const statusParam = params.get("status");

    if (token) {
      fetch(`http://localhost:5000/api/users/verify-email?token=${token}`)
        .then(() => {})
        .catch(() => setStatus("error"));
    } else if (statusParam) {
      setStatus(statusParam);
    } else {
      setStatus("error");
    }
  }, [location.search]);

  const messages = {
    success: {
      title: "Email Verified 🎉",
      message: "Your email has been successfully verified. You can now log in.",
      action: "Go to Login",
    },
    invalid: {
      title: "Invalid or Expired Link",
      message: "This verification link is invalid or has expired.",
      action: "Go to Login",
    },
    alreadyVerified: {
      title: "Already Verified",
      message: "Your email has already been verified. You can log in.",
      action: "Go to Login",
    },
    error: {
      title: "Verification Failed",
      message: "Something went wrong. Please try again or contact support.",
      action: "Go to Login",
    },
    loading: {
      title: "Verifying...",
      message: "Please wait while we verify your email.",
      action: null,
    },
  };

  const current = messages[status];

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      px={2}
    >
      <Card sx={{ maxWidth: 450, width: "100%", boxShadow: 3 }}>
        <CardContent sx={{ textAlign: "center" }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {current.title}
          </Typography>

          <Typography variant="body1" color="text.secondary" mb={3}>
            {current.message}
          </Typography>

          {current.action && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/login")}
              fullWidth
            >
              {current.action}
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default VerifyEmail;
